/** Attendance inclusion — generic HRMS defaults (all types Yes). */

export function attendanceIncludeDefault(_employmentType) {
  return true;
}

export function resolveIncludeInAttendance(employee) {
  const emp = employee?.employment || {};
  if (emp.include_in_attendance != null) return Boolean(emp.include_in_attendance);
  return attendanceIncludeDefault(emp.employment_type);
}

/** Same rules as backend Mark All (status + include + joining + LWD). */
export function isAttendanceEligibleOnDate(employee, dateStr, rosterStatuses) {
  const emp = employee?.employment || {};
  const status = (emp.status || "").trim();
  if (!rosterStatuses.includes(status)) return { ok: false, reason: "status" };
  if (!resolveIncludeInAttendance(employee)) return { ok: false, reason: "include_off" };
  const join = (emp.joining_date || "").slice(0, 10);
  const day = (dateStr || "").slice(0, 10);
  if (!join) return { ok: false, reason: "no_joining" };
  if (!day || day < join) return { ok: false, reason: "before_joining" };
  const lwd = (emp.last_working_date || "").slice(0, 10);
  if (lwd && day > lwd) return { ok: false, reason: "after_lwd" };
  return { ok: true, reason: "ok" };
}
